module.exports = __webpack_public_path__ + "static/assets/b059cafe6cf3c383b05c9d6ce7adea6c.png";